/**
 * @fileoverview Footer Component
 * 
 * This file contains the Footer component used throughout the Heidrick & Struggles
 * Leader Profile application. It displays copyright information and important links
 * like Privacy Notice, Terms of Use, and Contact.
 * 
 * The component relies on the footerValues function from commonFunctions.tsx
 * to get the list of links and their associated click handlers.
 */

import React from "react";
import { footerValues } from "./commonFunctions";

/**
 * Footer Component
 * 
 * Renders a consistent footer across the application with copyright text
 * and navigation links. The last link has a special styling and no divider after it.
 * 
 * @returns {JSX.Element} The rendered footer component
 */
const Footer = () => {

  return (
    <div className="footerWrapper">
      {/* Copyright text */}
      <div className="footerLogo">
        <img
          src='./../assets/img/HS_Logo_Footer.svg'
          alt="Heidrick & Struggles Logo"
        />
      </div>

      {/* Footer links from footerValues in commonFunctions */}
      <div className="footerLinks">
        {footerValues()?.map((item, index) => {
          // Check if this is the last item in the links array
          const lengthCheck = index + 1 === footerValues()?.length;

          return (
            <>
              {/* Link text with conditional styling based on position */}
              <div
                className={lengthCheck ? "footerPointer" : "footerSubTitle"}
                onClick={item.onClick}
              >
                {item.url}
              </div>

              {/* Divider between links, except after the last link */}
              {lengthCheck ? <></> : <div className="footerDivider"></div>}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default Footer;
